<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    export default {
        props: {
            label: String,
            value: [Number,String],
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable : {
                type: Boolean,
                default: false,
            },
            filterable : {
                type: Boolean,
                default: false,
            },
            onlyClient : {
                type: Boolean,
                default: false,
            },
            bonus : {
                type: Boolean,
                default: true,
            },
            direction: Number,
            cType: Number,
            id: [Number,String]
        },
        data() {
            return {
                val: 0,
                disabledVal: 0,
                allOptions: [],
            }
        },
        methods: {
            ...mapActions({
                get_list: 'dictionary/paymentOperation/get_list',
                get_listWithItem: 'dictionary/paymentOperation/get_listWithItem'
            }),
            change(v){
                this.$emit('change', v);
            }
        },
        computed: {
            ...mapState('dictionary/paymentOperation', {
                load: 'load',
            }),
            ...mapGetters('dictionary/paymentOperation', {
                getById: 'getById',
                list: 'list',
                sortList: 'sort_list'
            }),
            options() {
                const list = this.list(this.direction, this.cType, this.bonus);
                if (this.onlyClient) {
                    return list.filter(i => !(i.label || '').match(/(туроператор)|(центр(.)*бронирован)/i));
                } else {
                    return list;
                }
            },
            options2() {
                if (this.value) {
                    if (this.options.find(item => item.Id === this.value)) {
                        return this.options
                    } else {
                        this.disabledVal = this.value
                        const value = this.allOptions.find(item => item.Id === this.value);
                        if (value) {
                            return [...this.options, value]
                        } else {
                            return this.options
                        }
                    }
                } else {
                    return this.options
                }
            }
        },
        watch: {
            value(v){
                if (this.$route.meta.add && this.options && !this.options.find(item => +item.Id === this.val)) {
                    this.val = undefined
                } else {
                    this.get_listWithItem(v).then(data => {
                        this.allOptions = data
                    }).catch(() => {})
                    this.val = v
                }
            },
            val(v){
                this.$emit('input', v);
            },
        },
        components: {},
        created() {
            this.get_list().catch(() => {})
            if (this.value) {
                this.get_listWithItem(this.value).then(data => {
                    this.allOptions = data
                }).catch(() => {})
            }
            if (+this.id) {
                this.val = this.value;
            } else {
                this.val = undefined
            }
        },
        destroyed() {
        },
    }
</script>
<template>
    <div class="input-payment-operation">
        <div class="el-input-group el-input--mini" :class="{'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <el-select v-model="val" :disabled="disabled" :clearable="clearable" @change="change" :filterable="filterable">
                <el-option v-for="item in options2" :value="item.value" :key="item.value" :label="item.label" :disabled="disabledVal === item.Id" ></el-option>
            </el-select>
        </div>
        <div class="input__load" v-show="load">
            <i class="el-icon-loading"></i> Загрузка...
        </div>
    </div>
</template>
<style lang="scss">
    .input-payment-operation {
        position: relative;
        .el-select{
            width: 100%;
        }
    }
</style>
